import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardFooter, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { APP_NAME } from "@/config/constants";
import { Container } from "@/components/ui/container";
import { seo } from "@/utilities/seo";
import { Heading } from "@/components/ui/heading";

export const Route = createFileRoute("/_home/tools")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="col-span-12 container py-8 space-y-8">
      <div className="space-y-2">
        <Heading level="h1" size="h3" className="tracking-tight">
          Tools
        </Heading>
        <p className="text-muted-foreground">
          A collection of helpful tools created by the maker of {APP_NAME}.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card className="flex flex-col">
          <CardContent className="flex-1 p-6">
            <div className="space-y-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
                <span className="text-2xl">📅</span>
              </div>
              <div className="space-y-2">
                <CardTitle>ProgressCalendars.com</CardTitle>
                <CardDescription>
                  A directory of progress calendars that you can export to PDF and print.
                </CardDescription>
              </div>
            </div>
          </CardContent>
          <CardFooter className="p-6 pt-0">
            <Button
              variant="outline"
              className="w-full"
              onClick={() => window.open("https://progresscalendars.com", "_blank")}
            >
              <ExternalLink className="w-4 h-4 mr-2" />
              Visit Website
            </Button>
          </CardFooter>
        </Card>

        <Card className="flex flex-col">
          <CardContent className="flex-1 p-6">
            <div className="space-y-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
                <span className="text-2xl">💰</span>
              </div>
              <div className="space-y-2">
                <CardTitle>MoneyMouth.ai</CardTitle>
                <CardDescription>
                  All the tech of {APP_NAME} combined in a single template for AI startups.
                </CardDescription>
              </div>
            </div>
          </CardContent>
          <CardFooter className="p-6 pt-0">
            <Button
              variant="outline"
              className="w-full"
              onClick={() => window.open("https://www.moneymouth.ai", "_blank")}
            >
              <ExternalLink className="w-4 h-4 mr-2" />
              Visit Website
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
